import React from "react";
import { ChartLineUp } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";

export const ThresholdSetting = ({ threshold, onChange, onSave }) => (
  <div className="border border-zinc-300 p-3 bg-white">
    <div className="flex items-center gap-3 flex-wrap">
      <ChartLineUp size={18} weight="bold" className="text-zinc-700" />
      <div>
        <div className="text-xs uppercase tracking-widest font-bold text-zinc-500">Seuil de surconsommation</div>
        <div className="text-[11px] text-zinc-500">Au-delà de ce seuil, une alerte apparaît sur les camions et chauffeurs concernés.</div>
      </div>
      <div className="ml-auto inline-flex items-center gap-2">
        <Input
          type="number"
          step="0.1"
          value={threshold}
          onChange={(e) => onChange(parseFloat(e.target.value || "0"))}
          className="w-24 rounded-none border-zinc-900 mono text-right"
          data-testid="fuel-threshold-input"
        />
        <span className="text-xs font-bold">L/100 km</span>
        <button
          onClick={onSave}
          className="px-3 py-2 text-xs uppercase tracking-widest font-bold border border-zinc-900 bg-zinc-900 text-white hover:bg-zinc-700"
          data-testid="fuel-threshold-save"
        >
          Enregistrer
        </button>
      </div>
    </div>
  </div>
);
